import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "common/src/router/compat";
import { StyledFooterLinks } from "../styledComponents/StyledFooter";
import FooterText from "./FooterText";

const FooterLinks = ({
  pages,
  skin,
  player,
  switchTheme,
  currentTheme,
  server,
  footerHide,
  providerPageKeys,
}) => {
  const { t, i18n } = useTranslation("");
  const [isHover, setIsHover] = useState(false);
  const { geoIP } = server;
  const { country } = player;
  const isSWEIp =
    geoIP.isoCode.toLowerCase() === "se" || country === "se" ? true : false;

  const isSWEIpAndCasino =
    (geoIP.isoCode.toLowerCase() === "se" || country === "se") &&
    (skin === "yet" || skin === "fun" || skin === "hyc")
      ? true
      : false;

  const isUK =
    (player && player.country === "gb") || geoIP.isoCode.toLowerCase() === "gb";

  return (
    <>
      <StyledFooterLinks
        capitalize
        abcextra
        noborder={skin === "pub" || skin === "qbc" || skin === "bec"}
      >
        {pages["index"] && (
          <Link
            to={pages["index"]}
            dangerouslySetInnerHTML={{
              __html: t("label_home", "HOME"),
            }}
          ></Link>
        )}
        <Link
          to={!player ? pages["payments"] : pages["deposit"]}
          dangerouslySetInnerHTML={{
            __html: t("label_deposit", "DEPOSIT"),
          }}
        ></Link>
        <Link
          // className="dissable-nav-link"
          to={!player ? pages["payments"] : pages["withdrawal"]}
          dangerouslySetInnerHTML={{
            __html: t("label_withdrawal", "WITHDRAWAL"),
          }}
        ></Link>
        {player && isUK && (
          <Link
            to={pages["my-limits"]}
            dangerouslySetInnerHTML={{
              __html: t("label_limits"),
            }}
          ></Link>
        )}
        {pages["support"] && (
          <Link
            to={pages["support"]}
            dangerouslySetInnerHTML={{
              __html: t("label_support", "SUPPORT"),
            }}
          ></Link>
        )}
        {isSWEIpAndCasino
          ? null
          : pages["complaints"] && (
              <Link
                to={pages["complaints"]}
                dangerouslySetInnerHTML={{
                  __html: t("label_complaints", "COMPLAINTS"),
                }}
              ></Link>
            )}
        <Link
          to={pages["my-account"]}
          dangerouslySetInnerHTML={{
            __html: t("label_my_account", "MY ACCOUNT"),
          }}
        ></Link>
      </StyledFooterLinks>
      <StyledFooterLinks
        capitalize
        abc
        pubsize={skin === "pub"}
        pubcolor={skin === "pub"}
        noborder={skin === "qbc" || skin === "bec"}
        background={skin === "qbc" || skin === "bec"}
      >
        {pages["about-us"] && (
          <div>
            <Link
              to={pages["about-us"]}
              dangerouslySetInnerHTML={{ __html: t("label_about_us", "About") }}
            ></Link>
          </div>
        )}
        {pages["terms-and-conditions"] && (
          <div>
            <Link
              to={pages["terms-and-conditions"]}
              /*target="_blank"
            rel="noreferrer"*/
              dangerouslySetInnerHTML={{
                __html: t("label_terms_and_conditions", "Terms & Conditions"),
              }}
            ></Link>
          </div>
        )}
        {pages["sports-terms"] && (
          <div>
            <Link
              to={pages["sports-terms"]}
              /*target="_blank"
            rel="noreferrer"*/
              dangerouslySetInnerHTML={{
                __html: t("label_sports_terms_header", "Sports Terms"),
              }}
            ></Link>
          </div>
        )}
        {pages["sports-news"] && (
          <div>
            <Link
              to={pages["sports-news"]}
              /*target="_blank"
            rel="noreferrer"*/
              dangerouslySetInnerHTML={{
                __html: t("label_sports_news_header", "Sports News"),
              }}
            ></Link>
          </div>
        )}
        {pages["privacy-policy"] && (
          <div>
            <Link
              to={pages["privacy-policy"]}
              /*target="_blank"
            rel="noreferrer"*/
              dangerouslySetInnerHTML={{
                __html: t("label_privacy_policy", "Privacy & Safety"),
              }}
            ></Link>
          </div>
        )}
        {pages["responsible-gaming"] && (
          <div>
            <Link
              to={pages["responsible-gaming"]}
              /*target="_blank"
            rel="noreferrer"*/
              dangerouslySetInnerHTML={{
                __html: t("label_responsible_gaming", "Responsibile Gaming"),
              }}
            ></Link>
          </div>
        )}
        {pages["news-and-promotions"] && (
          <div>
            <Link
              to={pages["news-and-promotions"]}
              dangerouslySetInnerHTML={{
                __html: t("label_news_and_promotions", "News and Promotions"),
              }}
            ></Link>
          </div>
        )}
        {pages["faq"] && (
          <div>
            <Link
              to={pages["faq"]}
              dangerouslySetInnerHTML={{ __html: t("label_faq", "FAQ") }}
            ></Link>
          </div>
        )}
        {/* <div>
           {pages["jackpots"] && (
            <Link
              to={pages["jackpots"]}
              dangerouslySetInnerHTML={{
                __html: t("label_jackpots", "Jackpots"),
              }}
            ></Link>
          )}
        </div> */}
        {pages["bonus"] && (
          <div>
            <Link
              to={pages["bonus"]}
              dangerouslySetInnerHTML={{
                __html: t("label_bonus_footer", "Bonus"),
              }}
            ></Link>
          </div>
        )}
        {pages["tournaments"] && (
          <div>
            <Link
              to={pages["tournaments"]}
              dangerouslySetInnerHTML={{ __html: t("label_tournaments") }}
            ></Link>
          </div>
        )}
        <div>
          <a
            rel="noopener noreferrer"
            href={
              skin === "abc"
                ? "https://www.allbritishaffiliates.com/ "
                : skin === "pub"
                  ? "https://affiliates.pubcasino.co.uk"
                  : skin === "yet"
                    ? "https://www.yetiaffiliates.com/"
                    : skin === "fun"
                      ? "https://www.funcasinoaffiliates.com/"
                      : skin === "cac"
                        ? "https://www.casinocasinoaffiliates.com/"
                        : skin === "hyc"
                          ? "https://affiliates.hypercasino.com/"
                          : skin === "qbc"
                            ? "https://affiliates.quickbet.co.uk/"
                            : skin === "bec"
                              ? "https://www.becasinoaffiliates.com/"
                              : ""
            }
            target="_blank"
            dangerouslySetInnerHTML={{
              __html: t("label_affiliates", "Affiliates"),
            }}
          ></a>
        </div>
      </StyledFooterLinks>
      {skin === "pub" && !footerHide && (
        <FooterText
          skin={skin}
          pages={pages}
          providerPageKeys={providerPageKeys}
        />
      )}
    </>
  );
};

export default FooterLinks;
